import type { IconSvgObject } from './types';

const CornerRightUpIcon: IconSvgObject = [
  ["path", { d: "M15 5L15 12C15 15.7712 15 17.6569 13.8284 18.8284C12.6569 20 10.7712 20 7 20L4 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 8.99996C20 8.99996 16.3176 4.00001 15 4C13.6824 3.99999 10 9 10 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerRightUpIcon;
